import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';
import {LoggerService} from '../../../logging/services/logger.service';
import {LogLevel} from '../../../logging/data/logLevel';
import {LogSourceType} from '../../../logging/data/logSourceType';
import {LogSource} from '../../../logging/data/logSource';

@Component({
  selector: 'w-single-select',
  templateUrl: './single-select.component.html',
  styleUrls: ['./single-select.component.scss']
})
export class SingleSelectComponent implements OnInit, OnChanges {
  @Input() value: ISelectOption;
  @Input() options: ISelectOption[];
  @Input() label: string;
  @Input() hideLabel: boolean = false;
  @Input() highlightMode: 'check' | 'size' | 'highlightColor' = 'check';
  @Input() fixedItemWidth: string;

  @Output() valueChange: EventEmitter<ISelectOption> = new EventEmitter<ISelectOption>();

  selectedOption: ISelectOption;

  constructor(public domSanitizer: DomSanitizer,
              private loggingService: LoggerService) {
  }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes && changes.value && changes.value.currentValue) {
      this.value = changes.value.currentValue;
      this.selectedOption = this.value;
    }
  }

  selectOption(option: ISelectOption) {
    this.selectedOption = option;
    this.valueChange.emit(option);
    if (this.options && this.options.length > 0) {
      let isFlag = false;
      if (this.options[0].icon) {
        if (this.options[0].icon.includes('flag')) {
          isFlag = true;
        }
      }
      let isCarrier = false;
      if (this.options[0].value) {
        if (['USPS', 'FEDEX', 'UPS', 'DHL', 'Drop Off'].includes(this.options[0].value)) {
          isCarrier = true;
        }
      }
      if (!isCarrier && !isFlag) {
        this.loggingService.logMessage(LogLevel.INFO, LogSourceType.COMPONENT, LogSource.SingleSelectFieldComponent, 'Selected option: ' + (option.name ? option.name : option.icon));
      }
    }
  }

  getColorStyle(option: ISelectOption) {
    let style = '';
    if (this.highlightMode === 'highlightColor') {
      if (this.value === option) {
        style += `color: ${option.color};`;
      }
    } else {
      if (option.color) {
        style += `color: ${option.color};`;
      }
    }
    if (this.fixedItemWidth) {
      style += `width: ${this.fixedItemWidth}`;
    }
    return this.domSanitizer.bypassSecurityTrustStyle(style);
  }
}

export interface ISelectOption {
  name: string | undefined;
  icon: string | undefined;
  color: string | undefined;
  value: any;
}
